import {createBrowserHistory} from 'history';
import React from 'react';
import {hot} from 'react-hot-loader/root';
import {Redirect, Route, Router, Switch} from 'react-router-dom';
import {checkLogin} from '../auth';
import {Page} from '../styles';
import Home from './Home';
import MaintenanceHistoryPage from './MaintenanceHistoryPage';
import SystemDetails from './SystemDetails';
import SystemMap from './SystemMap';
import {OCCSideBar} from '../organisms';
import WithLeftNavBar from '../templates/WithLeftNavBar';

export const history = createBrowserHistory();

const inPage = Component => (
  <Page>
    <WithLeftNavBar NavBar={OCCSideBar}>
      <Component />
    </WithLeftNavBar>
  </Page>
);

const AppRouter = () => (
  <Router history={history}>
    <Switch>
      <Route
        path="/"
        exact
        render={() => (
          <Page>
            <Home />
          </Page>
        )}
      />
      <Route
        path="/system/:id"
        exact
        render={() =>
          checkLogin() ? inPage(SystemDetails) : <Redirect to="/" />
        }
      />
      <Route path="/map" render={() => inPage(SystemMap)} />
      <Route
        path="/maintenances"
        render={() => inPage(MaintenanceHistoryPage)}
      />
      <Redirect to="/" />
    </Switch>
  </Router>
);

export default hot(AppRouter);
